import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import './Common.css';

const TermsConditions = () => {
    return (
        <>
            <Header />
            <div className="mainhadding bullet">
                <ul>
                <h1>TERMS & CONDITION</h1>
                <li>
                Please read these terms and conditions along with our privacy policy both of which govern your use of our website sbstorefsd.com. If you do not agree to these terms and conditions and privacy policy then please do not register at our site or make any purchase through sbstorefsd.com. By registering and using our website, you agree to our terms and conditions and privacy policy.
                </li>
                <li>
                We may amend these terms and conditions from time to time, for which you will be notified by via email address which you provided at time of registration or by announcing such amendments at our website sbstorefsd.com.
                </li>
                <li>
                You must be 18 years of age to register with sbstorefsd.com. Please ensure that information provided by you at registration stage is correct and any subsequent change therein is notified to us.
                </li>
                <li>
                The password which you created at time of registration is to be kept confidential and safe.
                </li>
                <li>
                All orders and or activity undertaken under this password is your responsibility.
               </li>
                <li>
                You must please notify us immediately in the event of your discovering that someone else is using your password.
                </li>
                <li>
                If sbstorefsd.com suspects that your account is being misused, then we may suspend your account and inform you accordingly to request you to change your password.
                </li>
                <li>
                The contents of sbstorefsd.com are protected by copyrights and property rights.
                </li>
                <li>
                These contents are for your personal use and are not be used for any other purpose without specific written approval of sbstorefsd.com.
                </li>
                <li>
                Every effort is being made by sbstorefsd.com to provide you with the best possible service.
                </li>
                <li>
                However no warranties /guaranties are being offered by sbstorefsd.com that services will be fault free at all times.
                </li>
                <li>
                In the event of your dissatisfactions with any of our services, please contact us when we shall ensure to correct such fault.
                </li>
                <li>
                sbstorefsd.com may include links to other websites or materials which are beyond our control.
                </li>
                <li>
                Upon receipt of your order, we shall acknowledge its receipt, its only then that contract of sale is considered complete
                </li>
                <li>
                In the event of non availability of any product, we shall inform you accordingly for you to accept alternative item or accept the order with this product.
                </li>
                <li>
                Upon receipt of your order, once sbstorefsd.com has verified it, including availability of goods the approximate delivery time will be communicated to you via email or phone. You are expected to be present at that time to receive the delivery and to acknowledge its receipt. While every effort is made to deliver orders at agreed date and time, any delay due to circumstances beyond our control should be considered acceptable.
                </li>
                <li>
                sbstorefsd.com expects you to check your order upon receipt.
                </li>
                <li>
                If you have a change of mind in relation to any of the product delivered, you can return the same via the delivery person and your bill will be accordingly adjusted.
                </li>
                <li>
                For cancelation of any order, please do so prior to it has left our premise for delivery.
                </li>
                <li>
                You are not supposed to use sbstorefsd.com website for any unlawful purpose including but not limited to abusive, vulgar, offensive material.
                </li>
                <li>
                In case of any dispute the courts of Pakistan have the jurisdiction there on and any such matter will be referred to relevant courts based at Lahore Pakistan.
                </li>
                <li>
                www.sbstorefsd.com
                </li>
                </ul>
            </div>
            <Footer />
        </>
    )
}

export default TermsConditions;